import connector from 'api/http';
import {
  DirectDebitDetails,
  InsuranceName,
  PaymentDetailsData,
} from 'scenes/common/types';
import config from 'shared/config';
import {
  marshalBindBpayPayment,
  marshalBindCreditCardPayment,
  marshalBindDirectDebitPayment,
} from './marshaller';

const bindApi = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    bindBpayPayment: (
      insuranceName: InsuranceName,
      policyNumber: string,
      policyReference: string,
      paymentDetails: PaymentDetailsData
    ) =>
      Promise.resolve()
        .then(() =>
          marshalBindBpayPayment(
            insuranceName,
            policyNumber,
            policyReference,
            paymentDetails
          )
        )
        .then((request) => server.post('/quote/bind', request)),

    bindDirectDebitPayment: (
      insuranceName: InsuranceName,
      policyNumber: string,
      policyReference: string,
      paymentDetails: PaymentDetailsData,
      directDebitDetails: DirectDebitDetails
    ) =>
      Promise.resolve()
        .then(() =>
          marshalBindDirectDebitPayment(
            insuranceName,
            policyNumber,
            policyReference,
            paymentDetails,
            directDebitDetails
          )
        )
        .then((request) => server.post('/quote/bind', request)),

    bindCreditCardPayment: (
      insuranceName: InsuranceName,
      policyNumber: string,
      policyReference: string,
      paymentDetails: PaymentDetailsData,
      singleUseToken: string
    ) =>
      Promise.resolve()
        .then(() =>
          marshalBindCreditCardPayment(
            insuranceName,
            policyNumber,
            policyReference,
            paymentDetails,
            singleUseToken
          )
        )
        .then((request) => server.post('/quote/bind', request)),
  };
};

export default bindApi;
